import { useEffect, useRef } from 'react';
import { Flex, Scroll } from 'components';
import './style.scss';

interface IProps {
  month: number;
  onAccept: (month: number) => void;
}

function StageMonth(props: IProps) {
  const months = [
    'Январь',
    'Февраль',
    'Март',
    'Апрель',
    'Май',
    'Июнь',
    'Июль',
    'Август',
    'Сентябрь',
    'Октябрь',
    'Ноябрь',
    'Декабрь',
  ];
  return (
    <Flex
      direction='column'
      className='stage-kmIk'
      gap={10}
    >
      <Scroll>
        <Flex
          direction='column'
          gap={5}
        >
          {months.map((month, monthIndex) => (
            <Month
              onClick={() => props.onAccept(monthIndex)}
              key={monthIndex}
              monthName={month}
              selected={props.month === monthIndex}
            />
          ))}
        </Flex>
      </Scroll>
    </Flex>
  );
}

interface IMonthProps {
  monthName: string;
  selected: boolean;
  onClick: () => void;
}

function Month(props: IMonthProps) {
  let className = 'month-MaUW';

  if (props.selected) {
    className += ' sel-psfH';
  }

  return (
    <Flex
      justifyContent='center'
      className={className}
      onClick={props.onClick}
    >
      <div>{props.monthName}</div>
    </Flex>
  );
}
export default StageMonth;
